import { CollapsibleSectionList } from "./CollapsibleSectionList";

export default CollapsibleSectionList;
